import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {ATTEMPT_QUIZ, ATTEMPT_QUIZ_API_URL, GET_ALL_ATTEMPT_QUIZ_API_URL, STUDENT_QUIZZES_API_URL, STUDENT_QUIZ_START_API_URL, STUDENT_QUIZ_SUBMIT_API_URL, STUDENT_QUIZ_ATTEMPT_RESULT_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  AttemptQuizErrors       : {},
  permission: permission?.attempt_quiz ?? [],
  AttemptQuizShowMessage  : null,
  AttemptQuizResult       : [],
  AttemptQuizButtonSpinner : false,
  AttemptQuizTableLoading : true,
  AttemptQuizAddDrawer    : false,
  AttemptQuizEditData     : [],
  AttemptQuizButtonAndModelLabel  : setLocale('attemptquiz.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewAttemptQuizData: [],
    ViewAttemptQuizLoader: true,
    DrawerStatus: 0,
    studentQuizzes: null,
    studentQuizzesLoading: false,
    activeQuiz: null,
    activeQuizLoading: false,
    submitResult: null,
    submitLoading: false,
    attemptResult: null,
    attemptResultLoading: false,
};

export const createAttemptQuiz = createAsyncThunk(
    "createAttemptQuiz",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, ATTEMPT_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const getAttemptQuiz = createAsyncThunk(
    "getAttemptQuiz",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_ATTEMPT_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const viewAttemptQuiz = createAsyncThunk(
  "viewAttemptQuiz",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, ATTEMPT_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const deleteAttemptQuiz = createAsyncThunk(
  "deleteAttemptQuiz",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, ATTEMPT_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const getStudentQuizzes = createAsyncThunk(
  "getStudentQuizzes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CommonService.getAllPost({}, STUDENT_QUIZZES_API_URL);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Failed to load quizzes');
    }
  }
);

export const startStudentQuiz = createAsyncThunk(
  "startStudentQuiz",
  async (quizId, { rejectWithValue }) => {
    try {
      const response = await CommonService.createAndUpdate({ quiz_id: quizId }, STUDENT_QUIZ_START_API_URL);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to start quiz');
    }
  }
);

export const submitStudentQuiz = createAsyncThunk(
  "submitStudentQuiz",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CommonService.createAndUpdate(data, STUDENT_QUIZ_SUBMIT_API_URL);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to submit quiz');
    }
  }
);

export const getAttemptResult = createAsyncThunk(
  "getAttemptResult",
  async (attemptId, { rejectWithValue }) => {
    try {
      const response = await CommonService.createAndUpdate({ attempt_id: attemptId }, STUDENT_QUIZ_ATTEMPT_RESULT_API_URL);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to load attempt result');
    }
  }
);

export const manageAttemptQuizSlice = createSlice({
  name: ATTEMPT_QUIZ,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.AttemptQuizErrors = {};
    },
    AttemptQuizAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.AttemptQuizButtonSpinner = false;
      }
      state.AttemptQuizAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.AttemptQuizEditData    = [];
      state.AttemptQuizButtonAndModelLabel = setLocale('attemptquiz.add');
    },
    AttemptQuizEditWithDrawerStatus: (state, action) => {
      state.AttemptQuizAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.AttemptQuizEditData = action.payload.data;
      state.AttemptQuizButtonAndModelLabel = setLocale('attemptquiz.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
    clearActiveQuiz: (state) => {
      state.activeQuiz = null;
      state.submitResult = null;
      state.attemptResult = null;
    },
    clearSubmitResult: (state) => {
      state.submitResult = null;
      state.attemptResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAttemptQuiz.pending, (state, action) => {
        state.DrawerStatus = 0
        state.AttemptQuizButtonSpinner = true;
      }).addCase(createAttemptQuiz.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.AttemptQuizButtonSpinner = false;
        state.AttemptQuizErrors = {}
      }).addCase(createAttemptQuiz.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.AttemptQuizShowMessage = true;
        state.AttemptQuizButtonSpinner = false;
        state.AttemptQuizErrors = JSON.parse(action.error.message);
      }).addCase(getAttemptQuiz.pending, (state, action) => {
        state.AttemptQuizButtonSpinner = true;
        state.AttemptQuizTableLoading = true;
      }).addCase(getAttemptQuiz.fulfilled, (state, action) => {
        state.AttemptQuizButtonSpinner = false;
        state.AttemptQuizTableLoading = false;
        state.AttemptQuizResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getAttemptQuiz.rejected, (state, action) => {
        state.AttemptQuizShowMessage = true;
        state.AttemptQuizButtonSpinner = false;
        state.AttemptQuizTableLoading = false;
        state.AttemptQuizErrors = JSON.parse(action.error.message);
      })
      .addCase(viewAttemptQuiz.pending, (state, action) => {
        state.ViewAttemptQuizLoader = true;
        state.ViewAttemptQuizData = [];
      }).addCase(viewAttemptQuiz.fulfilled, (state, action) => {
        state.ViewAttemptQuizLoader = false;
        state.ViewAttemptQuizData = action.payload;
      }).addCase(viewAttemptQuiz.rejected, (state, action) => {
        state.ViewAttemptQuizLoader = false;
        state.ViewAttemptQuizData = [];
      })
      .addCase(deleteAttemptQuiz.pending, (state, action) => {
        state.AttemptQuizTableLoading = true;
      }).addCase(deleteAttemptQuiz.fulfilled, (state, action) => {
        state.AttemptQuizTableLoading = false;
      }).addCase(deleteAttemptQuiz.rejected, (state, action) => {
        state.AttemptQuizTableLoading = false;
      })
      .addCase(getStudentQuizzes.pending, (state) => {
        state.studentQuizzesLoading = true;
      }).addCase(getStudentQuizzes.fulfilled, (state, action) => {
        state.studentQuizzesLoading = false;
        state.studentQuizzes = action.payload;
      }).addCase(getStudentQuizzes.rejected, (state) => {
        state.studentQuizzesLoading = false;
        state.studentQuizzes = null;
      })
      .addCase(startStudentQuiz.pending, (state) => {
        state.activeQuizLoading = true;
        state.activeQuiz = null;
      }).addCase(startStudentQuiz.fulfilled, (state, action) => {
        state.activeQuizLoading = false;
        state.activeQuiz = action.payload;
      }).addCase(startStudentQuiz.rejected, (state) => {
        state.activeQuizLoading = false;
        state.activeQuiz = null;
      })
      .addCase(submitStudentQuiz.pending, (state) => {
        state.submitLoading = true;
      }).addCase(submitStudentQuiz.fulfilled, (state, action) => {
        state.submitLoading = false;
        state.submitResult = action.payload;
        state.attemptResult = action.payload;
        state.activeQuiz = null;
      }).addCase(submitStudentQuiz.rejected, (state) => {
        state.submitLoading = false;
      })
      .addCase(getAttemptResult.pending, (state) => {
        state.attemptResultLoading = true;
      }).addCase(getAttemptResult.fulfilled, (state, action) => {
        state.attemptResultLoading = false;
        state.attemptResult = action.payload;
        state.submitResult = action.payload;
      }).addCase(getAttemptResult.rejected, (state) => {
        state.attemptResultLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, AttemptQuizAddDrawerStatus, AttemptQuizEditWithDrawerStatus, updateSortFilters, clearActiveQuiz, clearSubmitResult } = manageAttemptQuizSlice.actions;

export default manageAttemptQuizSlice.reducer;
